import Table from '@/core/components/table/Table.tsx'
import useNotificationTable from '@/modules/utilities/notification/components/listNotifications/useNotificationTable.ts'
import useColumns from '@/modules/utilities/notification/components/listNotifications/useColumns.tsx'
import useActions from '@/modules/utilities/notification/components/listNotifications/useActions.ts'
import { useNavigate } from 'react-router-dom'
import { mapBackToFrontNotifications } from '@/modules/utilities/notification/utils/mapBackToFrontNotifications.ts'

const NotificationTable = () => {
  const navigate = useNavigate()
  const { rows, isLoadingTable, pagination } = useNotificationTable()

  const { handlerSelect } = useActions()

  const { columns } = useColumns()

  return (
    <Table
      columns={columns}
      rows={rows}
      loading={isLoadingTable}
      idField="id"
      pagination={pagination.paginationConf}
      onPageChange={pagination.handleChangePage}
      onRowsPerPageChange={pagination.handleChangeRowsPerPage}
      onRowClick={(row) => {
        if (row) {
          if (row.requestStatus !== 'LEÍDA') {
            handlerSelect(row.id)
          }
          const url = mapBackToFrontNotifications(row.requestReference)
          if (url) navigate(url)
        }
      }}
    />
  )
}

export default NotificationTable
